export const darkTheme = {
    name: 'dark',
    properties: {
        '--background-default': '#303030',
        '--background-paper': '#424242',
        '--text-primary': '#ffffff',
        // Add other theme properties
    }
};

export const lightTheme = {
    name: 'light',
    properties: {
        '--background-default': '#ffffff',
        '--background-paper': '#f5f5f5',
        '--text-primary': '#000000',
        // Add other theme properties
    }
};
